import { Accordion, AccordionDetails, AccordionSummary, Box } from '@hermes/web-components'
import { AccordionProps } from '@mui/material/Accordion'
import React from 'react'

interface SearchFilterAccordionProps extends AccordionProps {
  title: string
  icon?: React.ReactNode
}

export const SearchFilterAccordion: React.FC<SearchFilterAccordionProps> = ({
  title,
  icon,
  children,
  ...accordionProps
}) => (
  <Accordion
    {...accordionProps}
    sx={{
      '&:before': {
        display: 'none'
      },
      '&.Mui-expanded': {
        marginTop: '1px'
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }}
  >
    <AccordionSummary>
      {icon && <Box sx={{ mr: 1, width: 18, height: 18 }}>{icon}</Box>}
      {title}
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
)
